import { Link as RouterLink } from "@tanstack/react-router";
// Components
import { MergeDraftDialog } from "../../components/MergeDraftDialog";
// MUI
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { useBulkOrderMode } from "../../hooks/useAuthorisation";
import { getDraftBasePath } from "../../utils/orderPaths";

export function OrderListHeader({
  status,
  canMerge,
  selectedRows,
  setSelectedRows,
}) {
  const bulkOrderMode = useBulkOrderMode();
  let heading = "Draft Orders";
  if (status === "received") {
    heading = "Received Orders";
  } else if (status === "completed") {
    heading = "Completed Orders";
  } else if (status === "approved-orders") {
    heading = "Approved Orders";
  } else if (status === "approved-invoices") {
    heading = "Approved Invoices";
  }
  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        justifyContent: "space-between",
        alignItems: "center",
        pb: 1,
      }}
    >
      <Typography variant="h5">{heading}</Typography>
      <Stack direction="row" spacing={2}>
        {canMerge && (
          <MergeDraftDialog
            entityLabel="Orders"
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            disabled={false}
          />
        )}
        <Button
          variant="outlined"
          component={RouterLink}
          to={getDraftBasePath(bulkOrderMode)}
        >
          New Order
        </Button>
      </Stack>
    </Stack>
  );
}
